<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container">
	<h1 class="mb-4">Binders</h1>
	<!-- <p class="title-xs font-serra my-4">Binder Tool</p> -->
	<ul class="list bg-base-100 rounded-box shadow-md" [loading]="loading()">
	  <li class="header-container p-4 pb-2 text-xs opacity-60 tracking-wide">
	  	<span>Liste des binders</span>
		<a href="#" [routerLink]="router.get('admin-binder-add')" class="btn btn-square btn-ghost add-btn text-primary">
			<i class="fa-regular fa-layer-plus"></i>
		</a>
	  </li>
	  
	  @for(binder of binders(); track binder.ident){
		  <li class="list-row">
		    <div><img class="size-10" [altImg]="[binderS.getImg(binder.img)]"/></div>
		    <div>
		      <div>{{binder.brand}}</div>
              <div class="text-xs uppercase font-semibold opacity-60">{{binder.name}}</div>
		    </div>
		    <div>
		      <span class="badge badge-soft badge-sm text-xs font-semibold opacity-60" [ngClass]="getClassState(binder.state)">{{binder.state}}</span>
		    </div>
		    <a href="#" [routerLink]="router.parse('admin-binder-form', [binder.ident])" class="btn btn-square btn-ghost">
		      <i class="text-primary fa-regular fa-pen"></i>
		    </a>
		  </li>
	  }
	</ul>
</div>